module.exports = __webpack_public_path__ + "img/region_bg.4beb2c4c.png";